import {Component, Input} from '@angular/core';
import {ProjectReferenceSearchResponse} from '../../models/project-reference-search-response';
import {getRelevantProjectHandle} from '../../utils/project-name';

@Component({
    selector: 'app-project-reference-grid-item',
    templateUrl: './project-reference-grid-item.component.html',
    standalone: false
})
export class ProjectReferenceGridItemComponent {
    @Input() projectReference!: ProjectReferenceSearchResponse;
    getRelevantProjectHandle = getRelevantProjectHandle;
}
